import { render } from "./PlayoutView.vue?vue&type=template&id=497a7370"
import script from "./PlayoutView.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutView.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/TVPlayoutDash/PlayoutView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "497a7370"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('497a7370', __exports__)) {
    api.reload('497a7370', __exports__)
  }
  
  module.hot.accept("./PlayoutView.vue?vue&type=template&id=497a7370", () => {
    api.rerender('497a7370', render)
  })

}


export default __exports__